import * as types from '../mutation-types'
import { api } from '@/modules/api/index'
import { clone, pathOr } from 'ramda'

const state = {
  bannersList: [],
  bannerSettings: {},
  pageWithBanner: [],
  totalPages: 0,
  totalItems: 0
}

const getters = {
  getBannersList: state => state.bannersList,
  getbannerSettings: state => state.bannerSettings,
  getBannerById: state => id => state.bannersList.find(banner => banner.id === id),
  getTotalBannersPages: state => state.totalPages,
  getTotalBannersItems: state => state.totalItems,
  getPageInfoBanner: state => state.pageWithBanner
}

const actions = {
  async createBanner ({ commit }, banner) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      await this.$axios.post(api.banner.create(), banner)
      commit(types.CREATE_SUCCESS_MESSAGE, 'Banner was created')
      this.dispatch('fetchBanners')
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'FAILED: Create banner')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async savePageWithBanner ({ commit }, pageListWithBanner) {
    try {
      await this.$axios.put(api.banner.savePageWithBanner(), pageListWithBanner)
      commit(types.SET_PAGE_WITH_BANNER, [...pageListWithBanner.bannerSettings.pageWithBanner]
      )
      commit(types.CREATE_SUCCESS_MESSAGE, 'Saved')
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'FAILED: Load banners')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async fetchPageWithBanner ({ commit }) {
    try {
      const { data } = await this.$axios.get(api.generalSettings.getSettings())
      commit(types.SET_PAGE_WITH_BANNER, pathOr('', ['setting', 'bannerSetting', 'settingsObject', 'pageWithBanner'], data))
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'FAILED: Load banners')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async fetchBanners ({ commit }, payload = {}) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      const { data } = await this.$axios.get(api.banner.getBannersList(payload))
      commit(types.SET_BANNERS_LIST, data)
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'FAILED: Load banners')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async updateBanner ({ commit }, banner) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      await this.$axios.put(api.banner.update(), {...banner})
      commit(types.CREATE_SUCCESS_MESSAGE, 'Banner was updated')
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'FAILED: Update banner')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async deleteBanner ({ commit }, bannerId) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      const { data } = await this.$axios.get(api.generalSettings.getSettings())
      const newPagesWithBanner = data.setting.bannerSetting.settingsObject.pageWithBanner.map(item => {
        if (item.bannerId === bannerId) {
          return {
            bannerId: '',
            rowInterval: '',
            pageName: item.pageName,
            status: 'Disabled'
          }
        }
        return item
      })
      commit(types.SET_PAGE_WITH_BANNER, newPagesWithBanner)
      const formData = {
        bannerSettings: {
          pageWithBanner: newPagesWithBanner
        }
      }
      this.dispatch('savePageWithBanner', formData)
      await this.$axios.delete(api.banner.delete(bannerId))
      this.dispatch('fetchBanners')
      commit(types.CREATE_SUCCESS_MESSAGE, 'Banner was deleted')
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'FAILED: Delete banner')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  }
}

const mutations = {
  [types.SET_BANNERS_LIST] (state, data) {
    state.bannersList = [...data.banners]
    state.totalPages = data.totalPages
    state.totalItems = data.totalItems
  },
  [types.SET_BANNERS_DISPLAY_SETTINGS] (state, settings) {
    state.bannerSettings = clone(settings)
  },
  [types.SET_PAGE_WITH_BANNER] (state, page) {
    state.pageWithBanner = [...page]
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/banners.js